import { render, staticRenderFns } from "./OzInput.vue?vue&type=template&id=1385cfd3&scoped=true&"
import script from "./OzInput.vue?vue&type=script&lang=ts&"
export * from "./OzInput.vue?vue&type=script&lang=ts&"
import style0 from "./OzInput.vue?vue&type=style&index=0&id=1385cfd3&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1385cfd3",
  null
  
)

export default component.exports